import { render, staticRenderFns } from "./AdminSchema.vue?vue&type=template&id=f1e447c6&"
import script from "./AdminSchema.vue?vue&type=script&lang=js&"
export * from "./AdminSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports